import React, { useCallback, useEffect, useState } from "react";
import { Layout } from "../../components/layout/Layout";
import { PageHeader } from "../../components/layout/PageHeader";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/Card";
import { Button } from "../../components/ui/Button";
import { listScenarioDefinitions, upsertScenarioDefinition } from "../../services/api/scenarioLearning";

export default function TeacherScenarioCanDoPage() {
  const [items, setItems] = useState<Record<string, unknown>[]>([]);
  const [loading, setLoading] = useState(true);
  const [key, setKey] = useState("");
  const [titleEn, setTitleEn] = useState("");
  const [titleTa, setTitleTa] = useState("");
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const r = await listScenarioDefinitions();
      setItems(r.items ?? []);
    } catch {
      setItems([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  const save = async () => {
    if (!key.trim() || !titleEn.trim()) return;
    setBusy(true);
    try {
      await upsertScenarioDefinition({
        scenario_key: key.trim(),
        title_en: titleEn.trim(),
        title_ta: titleTa.trim(),
        difficulty: "medium",
        characters: [],
        linked_can_do_ids: [],
        prompt_style: "friendly",
      });
      setKey("");
      setTitleEn("");
      setTitleTa("");
      await load();
    } finally {
      setBusy(false);
    }
  };

  return (
    <Layout>
      <PageHeader title="Scenario & Can-Do mapping" subtitle="Tenant-specific scenario metadata (falls back to built-ins when empty)." />
      <div className="max-w-4xl mx-auto px-4 py-8 space-y-6">
        <Card className="border border-purple-100 shadow-md">
          <CardHeader>
            <CardTitle className="text-base">Upsert scenario</CardTitle>
          </CardHeader>
          <CardContent className="space-y-2">
            <input className="w-full px-3 py-2 rounded-lg border" placeholder="scenario_key" value={key} onChange={(e) => setKey(e.target.value)} />
            <input className="w-full px-3 py-2 rounded-lg border" placeholder="Title (EN)" value={titleEn} onChange={(e) => setTitleEn(e.target.value)} />
            <input className="w-full px-3 py-2 rounded-lg border" placeholder="Title (TA)" value={titleTa} onChange={(e) => setTitleTa(e.target.value)} />
            <Button onClick={() => void save()} disabled={busy}>
              Save
            </Button>
          </CardContent>
        </Card>
        <Card>
          <CardHeader>
            <CardTitle className="text-base">Definitions</CardTitle>
          </CardHeader>
          <CardContent>
            {loading ? (
              <p className="text-sm text-slate-500">Loading…</p>
            ) : (
              <ul className="text-sm space-y-1">
                {items.map((it) => (
                  <li key={String(it.scenario_key)} className="py-1 border-b border-slate-100">
                    <span className="font-medium">{String(it.scenario_key)}</span> — {String(it.title_en ?? "")}
                  </li>
                ))}
              </ul>
            )}
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}
